// src/pages/ContactPage.jsx - Updated with Calendly integration
import React, { useState } from 'react';
import { Calendar } from 'lucide-react';
import Contact from '../components/sections/Contact';
import SectionTitle from '../components/ui/SectionTitle';
import CalendlyWidget from '../components/ui/CalendlyWidget'; // Import the new component

const ContactPage = () => {
  const [activeTab, setActiveTab] = useState('form');
  
  // Your Calendly booking link for 30-minute consultations
  const calendlyUrl = "https://calendly.com/amvlaw-info/30min";
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-primary text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Have a question or need legal assistance? Get in touch with our team today.
          </p>
        </div>
      </div>
      
      {/* Tab Navigation */}
      <div className="container mx-auto px-4 pt-16">
        <div className="flex mb-6 border-b border-gray-200 max-w-md mx-auto">
          <button
            onClick={() => setActiveTab('form')}
            className={`px-6 py-3 font-medium ${
              activeTab === 'form'
                ? 'text-primary border-b-2 border-primary -mb-px'
                : 'text-gray-600 hover:text-primary'
            }`}
          >
            Contact Form
          </button>
          
          <button
            onClick={() => setActiveTab('calendly')}
            className={`px-6 py-3 font-medium ${
              activeTab === 'calendly'
                ? 'text-primary border-b-2 border-primary -mb-px'
                : 'text-gray-600 hover:text-primary'
            }`}
          >
            Schedule Consultation
          </button>
        </div>
      </div>
      
      {/* Contact Form Tab */}
      {activeTab === 'form' ? (
        <Contact />
      ) : (
        /* Calendly Tab */
        <section className="py-8">
          <div className="container mx-auto px-4">
         
            
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-md p-6 mb-8 animate-[fadeIn_0.5s_ease-out]">
               
                
                {/* Using the new CalendlyWidget component */}
                <CalendlyWidget 
                  calendarUrl={calendlyUrl} 
                  height="500px"
                  className="shadow-sm"
                />
              </div>
            </div>
          </div>
        </section>
      )}
      
      {/* Map Section */}
      <section className="py-8 pb-16">
        <div className="container mx-auto px-4">
          <SectionTitle 
            title="Our Locations" 
            subtitle="Find our offices in Delhi and Noida"
          />
          
          <div className="rounded-lg overflow-hidden shadow-lg h-96 mt-8">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.551158433352!2d77.16713231508338!3d28.6475773824054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0337ed0a3cbb%3A0xc62c9b1ea8f0d8fe!2sEast%20Patel%20Nagar%2C%20Patel%20Nagar%2C%20New%20Delhi%2C%20Delhi%20110008!5e0!3m2!1sen!2sin!4v1617546335617!5m2!1sen!2sin" 
              width="100%" 
              height="100%" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy"
              title="AMV Law Office Location"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;